import { createModule } from '../type'
export class UpdatePwd{
  password?: string
  newPassWord?: string
  confirmPassWord?: string
  phone?:string
  displayname?:string

}
export default createModule([
  {
    path: '/', redirect: '/middleware'
  },
  {
    path: '/login', name: 'Login',
    component: () => import('../../views/login/login.vue')
  },
  {
    path: '/middleware', name: 'Middleware',
    component: () => import('@views/MiddlewareView.vue')
  },
])
